import React, { createContext, useContext, useState, useEffect } from 'react'

const ThemeContext = createContext()

// Aplica o tema antes do React renderizar para evitar flash
if (typeof window !== 'undefined') {
  const savedTheme = localStorage.getItem('app-theme') || 'light'
  if (savedTheme === 'dark') {
    document.body.classList.add('dark')
    document.documentElement.classList.add('dark')
    // Aplica estilo inline no NavHeader se existir
    const style = document.createElement('style')
    style.textContent = `
      [data-nav-header] {
        background-color: hsl(215, 35%, 12%) !important;
      }
    `
    document.head.appendChild(style)
  } else {
    document.body.classList.remove('dark')
    document.documentElement.classList.remove('dark')
    // Aplica estilo inline no NavHeader se existir
    const style = document.createElement('style')
    style.textContent = `
      [data-nav-header] {
        background-color: #FFFFFF !important;
      }
    `
    document.head.appendChild(style)
  }
}

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme deve ser usado dentro de ThemeProvider')
  }
  return context
}

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Recupera o tema salvo no localStorage ou usa 'light' como padrão
    const savedTheme = localStorage.getItem('app-theme')
    const initialTheme = savedTheme || 'light'
    
    // Aplica o tema imediatamente na inicialização
    if (initialTheme === 'dark') {
      document.body.classList.add('dark')
      document.documentElement.classList.add('dark')
    } else {
      document.body.classList.remove('dark')
      document.documentElement.classList.remove('dark')
    }
    
    return initialTheme
  })

  useEffect(() => {
    // Salva o tema no localStorage quando mudar
    localStorage.setItem('app-theme', theme)
    // Aplica a classe 'dark' no body para o tema escuro
    if (theme === 'dark') {
      document.body.classList.add('dark')
      document.documentElement.classList.add('dark')
    } else {
      document.body.classList.remove('dark')
      document.documentElement.classList.remove('dark')
    }
  }, [theme])

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light')
  }

  const value = {
    theme,
    setTheme,
    toggleTheme,
    isDark: theme === 'dark'
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}
